import React from 'react'
import { Cloud } from 'lucide-react'

function LoadingSpinner() {
  return (
    <div className="min-h-96 flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          <Cloud className="h-12 w-12 text-primary-600 mx-auto animate-pulse" />
          <div className="absolute inset-0 h-12 w-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin mx-auto"></div>
        </div>
        <p className="text-gray-600 mt-4">Loading cloud providers...</p>
        <p className="text-sm text-gray-500 mt-1">Please wait while we fetch the latest data</p>
      </div>
    </div>
  )
}

export default LoadingSpinner 